import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'; // Import HttpClientModule
import { NgModule } from '@angular/core';

import { CustomerDataService } from './services/customer-data.service';
import { CdwCustomerApiLookupStrategy } from './strategies/cdw-customer-api-lookup.strategy';
import { MockCustomerLookupStrategy } from './strategies/mock-customer-lookup.strategy';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    CustomerDataService,
    CdwCustomerApiLookupStrategy,
    MockCustomerLookupStrategy,
  ],
})
export class CustomerLookupModule {}
